<script setup>
import { computed } from 'vue';
import { ArrowDown01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';

import HugeIcon from 'dashboard/components-next/icon/HugeIcon.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  open: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle']);

const sectionIcon = computed(() =>
  props.open ? ArrowDown01Icon : ArrowRight01Icon
);
</script>

<template>
  <button
    type="button"
    class="flex w-full cursor-pointer items-center gap-2.5 pb-1 pt-2 text-start"
    :aria-expanded="open"
    @click="emit('toggle', $event)"
  >
    <HugeIcon
      :icon="sectionIcon"
      :size="24"
      class="size-6 shrink-0 text-n-slate-11"
      :class="!open && 'rtl:rotate-180'"
    />
    <span class="min-w-0 flex-1 text-heading-2 text-n-slate-12">
      {{ title }}
    </span>
  </button>
</template>
